import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  chatbox: {
    fontFamily: 'Dosis, sans-serif',
    maxWidth: '310px',
    width: '100%',
    minWidth: '310px',
    height: '400px',
    backgroundColor: 'aliceblue',
    padding: '12px',
    display: 'flex',
    overflow: 'hidden',
    overflowY: 'scroll',
    flexDirection: 'column',
    border: '1px solid #b3e5fc',
  },
  chatboxHeaderContainer: {
    backgroundColor: '#81d4fa',
    height: '36px',
    margin: '-12px -12px 0 -12px',
    border: '1px solid #81d4fa',
    display: 'flex',
    justifyContent: 'space-evenly',
    padding: '',
    alignItems: 'center',
    fontFamily: 'Dosis, sans-serif',
  },
  chatboxHeader: {
    display: 'flex',
    textAlign: 'end',
    height: '100%',
    width: '100%',
  },
  chatArea: {
    display: 'block',
    overflow: 'hidden',
    overflowY: 'scroll',
    height: '270px',
    width: '100%',
    scrollbarWidth: 0,
    scrollbarColor: 'transparent',
  },
  avatarContainer: {
    width: '36px',
    height: '36px',
    minWidth: '36px',
    minHeight: '36px',
    backgroundColor: 'white',
    border: 'px solid lightblue',
    borderRadius: '18px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '12px',
  },
  catIcon: {
    width: '24px',
    minWidth: '24px',
    height: '24px',
    minHeight: '24px',
  },
  userBubbleContainer: {
    display: 'flex',
    justifyContent: 'end',
    marginTop: '12px',
  },
  userBubble: {
    minHeight: '14px',
    minWidth: '14px',
    height: 'fit-content',
    backgroundColor: 'lightblue',
    textAlign: 'left',
    position: 'relative',
    maxWidth: '60%',
    padding: '8px',
    marginRight: '12px',
    borderRadius: '10px',
    overflowWrap: 'anywhere',
    '&:before': {
      content: '" "',
      position: 'absolute',
      width: '0',
      height: '0',
      borderTop: '12px solid lightblue',
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent',
      top: '3px',
      right: '-6px',
    },
    '&:after': {
      content: '" "',
      position: 'absolute',
      width: '0',
      height: '0',
      borderTop: '1px solid lightblue',
      borderLeft: '9px solid transparent',
      borderRight: '9px solid transparent',
      top: '3px',
      right: '-8px',
    },
  },
  catBubbleContainer: {
    display: 'flex',
    marginTop: '12px',
  },
  catBubbleNoTail: {
    marginTop: '8px',
    minHeight: '14px',
    minWidth: '14px',
    height: 'fit-content',
    backgroundColor: '#fce4ec',
    maxWidth: '60%',
    padding: '8px',
    borderRadius: '10px',
  },
  catBubble: {
    marginTop: '4px',
    minHeight: '14px',
    minWidth: '14px',
    height: 'fit-content',
    backgroundColor: '#fce4ec',
    maxWidth: '60%',
    padding: '8px',
    borderRadius: '10px',
    position: 'relative',
    '&:before': {
      content: '" "',
      position: 'absolute',
      width: '0',
      height: '0',
      borderTop: '10px solid #fce4ec',
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent',
      top: '3px',
      left: '-8px',
    },
    '&:after': {
      content: '" "',
      position: 'absolute',
      width: '0',
      height: '0',
      borderTop: '1px solid #fce4ec',
      borderLeft: '9px solid transparent',
      borderRight: '9px solid transparent',
      top: '3',
      left: '-8px',
    },
  },
  textareaContainer: { display: 'fixed', width: '120%' },
});
